import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../../core/context/store';
import { PrimaryButton, SecondaryButton } from '../../../../core/components/button';
import { sessionActions, standardSequencesActions } from '../../actions';
import { SessionProps } from '../../models';

export interface InstanceNotRunningModalProps {
  sessionId: number;
  showModal: boolean;
}

export const InstanceNotRunningModal = ({ sessionId, showModal }: InstanceNotRunningModalProps): React.ReactElement => {
  const history = useHistory();
  const [, activeSessionStoreActions] = useStore<SessionProps>('active-session');
  const [hasDismissedModal, setHasDismissedModal] = useState(false);

  const onClickHandler = () => {
    activeSessionStoreActions.dispatch(
      sessionActions.closeSession(sessionId, () => {
        history.push('/courses');
        activeSessionStoreActions.dispatch(standardSequencesActions.clearSessionData());
      })
    );
  };

  return (
    <Modal show={showModal && !hasDismissedModal} centered>
      <Modal.Header>
        <Modal.Title>Session expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        The simulator session has expired. To continue using the simulator, please dismiss this message, save any
        unsaved changes and then close the module and start the module again.
      </Modal.Body>
      <Modal.Footer>
        <SecondaryButton
          className="simulator-instance-not-running-modal--secondary-button"
          onClick={() => setHasDismissedModal(true)}
        >
          Dismiss
        </SecondaryButton>
        <PrimaryButton onClick={onClickHandler}>Close module</PrimaryButton>
      </Modal.Footer>
    </Modal>
  );
};
